// removed by extract-text-webpack-plugin
module.exports = {"basic-info":"basic-info__1tx2U","avatar-card":"avatar-card__Z34EL","avatar-img":"avatar-img__1c51g","avatar-desc":"avatar-desc__us25O","content-card":"content-card__tlfpr","bold-title":"bold-title__5nYpW","balance":"balance__2Lr_A","balance-val":"balance-val__XGxy4","bills-info":"bills-info__28orG","billday":"billday__3f0jJ","billday-val":"billday-val__rHyE7","bill-help":"bill-help__2wZoM","extra-pd":"extra-pd__337_n"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Billing/coms/CommercialView/styles/main.scss
// module id = 2254
// module chunks = 1